/*
 * types/services/collection.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';

/**
 * The CollectionCollectionBase model module.
 * @module model/CollectionCollectionBase
 * @version version not set
 */
export class CollectionCollectionBase {
  /**
   * Constructs a new <code>CollectionCollectionBase</code>.
   * @alias module:model/CollectionCollectionBase
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CollectionCollectionBase</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CollectionCollectionBase} obj Optional instance to populate.
   * @return {module:model/CollectionCollectionBase} The populated <code>CollectionCollectionBase</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CollectionCollectionBase();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
CollectionCollectionBase.prototype.id = undefined;

/**
 * @member {String} name
 */
CollectionCollectionBase.prototype.name = undefined;


